<div class="page-wrapper">

  <!-- Page Header -->
  <div class="page-header">
    <div class="page-title-block">
      <div class="page-icon">
        <i class="fa fa-rotate-left"></i>
      </div>
      <div>
        <h1 class="page-title">Avoirs & Retours</h1>
        <p class="page-subtitle">Journal des remboursements et retours clients</p>
      </div>
    </div>
  </div>

  <!-- Stat Cards -->
  <div class="stat-row">
    <div class="stat-card">
      <div class="stat-label">Total Avoirs</div>
      <div class="stat-value">{{ totalElements }}</div>
      <div class="stat-icon stat-icon-total"><i class="fa fa-layer-group"></i></div>
    </div>
    <div class="stat-card">
      <div class="stat-label">En Attente</div>
      <div class="stat-value stat-pending">{{ pendingCount }}</div>
      <div class="stat-icon stat-icon-pending"><i class="fa fa-hourglass-half"></i></div>
    </div>
    <div class="stat-card">
      <div class="stat-label">Approuvés</div>
      <div class="stat-value stat-approved">{{ approvedCount }}</div>
      <div class="stat-icon stat-icon-approved"><i class="fa fa-check-circle"></i></div>
    </div>
    <div class="stat-card">
      <div class="stat-label">Total Remboursé</div>
      <div class="stat-value">{{ totalRefunded | number:'1.2-2' }} <small>MAD</small></div>
      <div class="stat-icon stat-icon-amount"><i class="fa fa-coins"></i></div>
    </div>
  </div>

  <!-- Filter Bar -->
  <div class="filter-bar">
    <div class="search-wrap">
      <i class="fa fa-search search-icon"></i>
      <input
        type="text"
        [(ngModel)]="keyword"
        (keyup.enter)="onSearch()"
        placeholder="Recherche par ID, commande ou client…"
        class="search-input"
      />
    </div>
    <input type="date" [(ngModel)]="selectedDate" (change)="onDateChange()" class="date-input" />
    <button (click)="onSearch()" class="btn-filter">
      <i class="fa fa-sliders-h"></i> Filtrer
    </button>
  </div>

  <!-- Table Card -->
  <div class="table-card">

    <!-- Loading -->
    <div *ngIf="isLoading" class="state-block">
      <i class="fa fa-circle-notch fa-spin state-icon"></i>
      <p class="state-text">Chargement des avoirs…</p>
    </div>

    <!-- Empty -->
    <div *ngIf="!isLoading && avoirs.length === 0" class="state-block">
      <i class="fa fa-inbox state-icon"></i>
      <p class="state-text">Aucun avoir trouvé pour les filtres sélectionnés.</p>
    </div>

    <!-- Table -->
    <table *ngIf="!isLoading && avoirs.length > 0" class="av-table">
      <colgroup>
        <col style="width: 90px;" />
        <col style="width: 140px;" />
        <col style="width: 120px;" />
        <col style="width: auto;" />
        <col style="width: 110px;" />
        <col style="width: 90px;" />
        <col style="width: 140px;" />
        <col style="width: 90px;" />
      </colgroup>
      <thead>
        <tr>
          <th>Réf.</th>
          <th>Date</th>
          <th>Commande</th>
          <th>Client</th>
          <th>État</th>
          <th>Articles</th>
          <th>Total</th>
          <th class="text-right">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let avoir of avoirs" (click)="viewDetails(avoir.id!)" class="av-row">

          <td>
            <span class="av-id">AV-{{ avoir.id }}</span>
          </td>

          <td>
            <div class="row-date">
              <span class="date-text"><i class="fa fa-calendar-day"></i> {{ avoir.avoirDate | date:'dd/MM/yyyy' }}</span>
              <span class="time-text">{{ avoir.avoirDate | date:'HH:mm' }}</span>
            </div>
          </td>

          <td>
            <div class="cmd-chip">
              #{{ avoir.originalOrderId }}
            </div>
          </td>

          <td>
            <div class="client-cell">
              <div class="client-avatar">{{ (avoir.originalOrder?.client?.nom || 'C')[0] | uppercase }}</div>
              <div class="client-info">
                <div class="client-name">{{ avoir.originalOrder?.client?.nom || 'Client' }} {{ avoir.originalOrder?.client?.prenom || 'Divers' }}</div>
                <div *ngIf="avoir.notes" class="cell-note">{{ avoir.notes }}</div>
              </div>
            </div>
          </td>

          <td>
            <span class="status-pill"
              [ngClass]="{
                'pill-approved':  avoir.status === 'APPROVED',
                'pill-completed': avoir.status === 'COMPLETED',
                'pill-ready':     avoir.status === 'READY_TO_APPROVE',
                'pill-rejected':  avoir.status === 'REJECTED',
                'pill-pending':   avoir.status === 'PENDING' || !avoir.status
              }">
              <span class="pill-dot"></span>
              {{ avoir.status === 'READY_TO_APPROVE' ? 'PRÊT À VALIDER' : (avoir.status || 'PENDING') }}
            </span>
          </td>

          <td>
            <span class="cell-badge">{{ avoir.avoirLines.length }}</span>
          </td>

          <td>
            <span class="av-amount">{{ avoir.totalRefund | number:'1.2-2' }}</span>
            <span class="av-currency">MAD</span>
          </td>

          <td class="text-right" (click)="$event.stopPropagation()">
            <div class="dropdown-wrap">
              <button class="kebab-btn" (click)="toggleDropdown(avoir.id!, $event)" title="Actions">
                <i class="fa fa-ellipsis-vertical"></i>
              </button>
              <div class="dropdown-menu" [class.open]="openDropdownId === avoir.id">
                <button class="dd-item dd-view" (click)="viewDetails(avoir.id!); closeDropdown()">
                  <i class="fa fa-eye"></i> Voir détails
                </button>
                <button class="dd-item dd-edit"
                  [disabled]="avoir.status === 'APPROVED' || avoir.status === 'COMPLETED' || avoir.status === 'REJECTED'"
                  (click)="onEdit(avoir, $event); closeDropdown()">
                  <i class="fa fa-pen"></i> Modifier
                </button>
                <button class="dd-item dd-approve"
                  [disabled]="avoir.status !== 'READY_TO_APPROVE'"
                  (click)="approveAvoirManual(avoir.id!, $event); closeDropdown()">
                  <i class="fa fa-check"></i> Approuver
                </button>
                <div class="dd-divider"></div>
                <button class="dd-item dd-delete" 
                  [disabled]="avoir.status === 'APPROVED' || avoir.status === 'COMPLETED' || avoir.status === 'REJECTED'"
                  (click)="deleteAvoir(avoir, $event); closeDropdown()">
                  <i class="fa fa-trash"></i> Supprimer
                </button>
              </div>
            </div>
          </td>

        </tr>
      </tbody>
    </table>

    <!-- Pagination -->
    <div *ngIf="totalPages > 1" class="pag-bar">
      <span class="pag-info">
        {{ currentPage * pageSize + 1 }}–{{ (currentPage + 1) * pageSize > totalElements ? totalElements : (currentPage + 1) * pageSize }}
        sur {{ totalElements }} entrées
      </span>
      <div class="pag-controls">
        <button (click)="onPageChange(currentPage - 1)" [disabled]="currentPage === 0" class="pag-btn">
          <i class="fa fa-chevron-left"></i>
        </button>
        <span class="pag-page">{{ currentPage + 1 }} / {{ totalPages }}</span>
        <button (click)="onPageChange(currentPage + 1)" [disabled]="currentPage === totalPages - 1" class="pag-btn">
          <i class="fa fa-chevron-right"></i>
        </button>
      </div>
    </div>

  </div>

  <!-- Custom Confirmation Dialog -->
  <app-confirmation-dialog
    [isVisible]="isConfirmVisible"
    [title]="confirmTitle"
    [message]="confirmMessage"
    [type]="confirmType"
    [confirmText]="confirmBtnText"
    (confirm)="handleConfirm()"
    (cancel)="handleCancel()"
    (close)="isConfirmVisible = false">
  </app-confirmation-dialog>
</div>
